import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Склейка классов с разрешением конфликтов Tailwind.
 *
 * Нужна именно из-за вариантов CVA: у компонента есть базовые классы, а
 * пропс `className` должен уметь их переопределить, а не встать рядом.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
